import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dropdown, Form } from 'react-bootstrap';
import { Formik, Field } from 'formik';
import moment from 'moment';

const LogsList = ({ logs }) => (
  <ul className="list-unstyled mt-4">
    {logs.map((log, index) => {
      const statusText = (status) => {
        switch (status) {
          case 'submit':
            return 'submitted';
          case 'approve':
            return 'approved';
          case 'reject':
            return 'rejected';
          case 'withdraw':
            return 'withdrawn';
          default:
            return status;
        }
      };
      return (
        <li key={`log-${index}`}>
          <small>
            <span className="text-muted">
              {moment(log.updatedDate).format('MMM D hh:mm a')}{' '}
              {statusText(log.status)} by {log.updatedBy.firstName}
            </span>
            {log.note && `: ${log.note}`}
          </small>
        </li>
      );
    })}
  </ul>
);

LogsList.propTypes = {
  logs: PropTypes.array,
};

const WeeklyStatusApprovalToggle = ({
  status,
  logs,
  wsWeekDetails,
  wsWeekStatusUpdate,
  weeklySubmissionId,
  userId,
}) => {
  switch (status) {
    case 'submit':
      return (
        <Dropdown>
          <Dropdown.Toggle
            as={Button}
            size="sm"
            variant="white"
            className="mt-2"
            to={{ hash: '#' }}
          >
            <i className="mdi mdi-check-circle me-1 text-warning" />
            Pending for approval
          </Dropdown.Toggle>

          <Dropdown.Menu
            className="dropdown-menu-right p-3 mt-1"
            style={{ minWidth: '300px' }}
          >
            <p className="mb-2 text-uppercase">
              <small>
                Week of {moment(wsWeekDetails.startDate).format('MMM D')} -{' '}
                {moment(wsWeekDetails.endDate).format('MMM D')}{' '}
              </small>
            </p>
            <Formik
              initialValues={{
                notes: '',
              }}
              onSubmit={(values) => {
                wsWeekStatusUpdate({
                  weeklySubmissionId,
                  teamMember: userId,
                  status: 'approve',
                  note: values.notes,
                });
              }}
            >
              {(formikprops) => (
                <Form onSubmit={formikprops.handleSubmit}>
                  <Form.Group controlId="wsNotes" className="mb-3">
                    <Field
                      as="textarea"
                      maxLength="300"
                      name="notes"
                      rows="2"
                      className="form-control"
                      placeholder="Notes"
                    />
                  </Form.Group>
                  <Button
                    variant="primary"
                    type="submit"
                    size="sm"
                    className="me-2"
                  >
                    Approve
                  </Button>
                  <Button
                    variant="white"
                    type="button"
                    size="sm"
                    onClick={() =>
                      wsWeekStatusUpdate({
                        weeklySubmissionId,
                        teamMember: userId,
                        status: 'reject',
                        note: formikprops.values.notes,
                      })
                    }
                  >
                    Reject
                  </Button>
                </Form>
              )}
            </Formik>
            {logs && logs.length > 0 && <LogsList logs={logs} />}
          </Dropdown.Menu>
        </Dropdown>
      );
    case 'approve':
      return (
        <Dropdown>
          <Dropdown.Toggle
            as={Button}
            size="sm"
            variant="white"
            className="mt-2"
            to={{ hash: '#' }}
          >
            <i className="mdi mdi-check-circle me-1 text-success" />
            Approved
          </Dropdown.Toggle>

          <Dropdown.Menu
            className="dropdown-menu-right p-3 mt-1"
            style={{ minWidth: '300px' }}
          >
            <p className="mb-2 text-uppercase">
              <small>
                Week of {moment(wsWeekDetails.startDate).format('MMM D')} -{' '}
                {moment(wsWeekDetails.endDate).format('MMM D')}{' '}
              </small>
            </p>
            {logs && logs.length > 0 && <LogsList logs={logs} />}
          </Dropdown.Menu>
        </Dropdown>
      );
    case 'reject':
      return (
        <Dropdown>
          <Dropdown.Toggle
            as={Button}
            size="sm"
            variant="white"
            className="mt-2"
            to={{ hash: '#' }}
          >
            <i className="mdi mdi-close-circle me-1 text-danger" />
            Rejected
          </Dropdown.Toggle>

          <Dropdown.Menu
            className="dropdown-menu-right p-3 mt-1"
            style={{ minWidth: '300px' }}
          >
            <p className="mb-2 text-uppercase">
              <small>
                Week of {moment(wsWeekDetails.startDate).format('MMM D')} -{' '}
                {moment(wsWeekDetails.endDate).format('MMM D')}{' '}
              </small>
            </p>
            {logs && logs.length > 0 && <LogsList logs={logs} />}
          </Dropdown.Menu>
        </Dropdown>
      );
    default:
      return (
        <Button
          variant="white"
          size="sm"
          className="text-muted border"
          disabled
        >
          <i className="mdi mdi-check-circle me-1" />
          Not Submitted
        </Button>
      );
  }
};

WeeklyStatusApprovalToggle.propTypes = {
  status: PropTypes.string,
  logs: PropTypes.array,
  wsWeekDetails: PropTypes.object,
  wsWeekStatusUpdate: PropTypes.func,
  weeklySubmissionId: PropTypes.string,
  userId: PropTypes.string,
};

export default WeeklyStatusApprovalToggle;
